<template>
  <div :key="refresh_key">
    <!-- *** IME **** -->
    <form-input :invalid="invalid_elements.ime" :label="$t('forms.person.phys_pers.name_lbl')" id="ime" ref="imeFiz" required="required"
      :base="fizicka.ime"></form-input>
    <!-- *** Prezime **** -->
    <form-input :invalid="invalid_elements.prezime" :label="$t('forms.person.phys_pers.surname_lbl')" id="prezime" ref="prezimeFiz" required="required"
      :base="fizicka.prezime"></form-input>
    <!-- OIB -->
    <form-input :label="$t('forms.person.phys_pers.oib')" id="oib" ref="OIB" :base="fizicka.oib"></form-input>
    <!-- <div class="form-input-wrapper">
      <label class="form-label" for="datum-rodjenja">
        <span>Datum rođenja</span>
      </label>
      <div>
        <input class="form-input" type="date" id="datum-rodjenja" ref="datumRodjenja" name="datum-rodjenja"
          @input="fizicka.rodjendan = $event.target.value" v-model="fizicka.rodjendan" />
      </div>
    </div> -->

    <!-- *** Email *** -->
    <form-input-multiple ref="email" :name="'email'" :label="$t('forms.person.phys_pers.email_lbl')" :placeholder="$t('forms.person.phys_pers.email_plh')"
      :base="fizicka.email_list" />
    <!-- *** Broj telefona *** -->
    <form-input-multiple ref="telefon" :name="'telefon'" :label="$t('forms.person.phys_pers.tel_lbl')" :placeholder="$t('forms.person.phys_pers.tel_plh')" :base="fizicka.tel_br_list" />
    <!-- *** Web stranica *** -->
    <form-input-multiple ref="stranica" :name="'stranica'" :label="$t('forms.person.phys_pers.web_lbl')" :placeholder="$t('forms.person.phys_pers.web_plh')" :base="fizicka.web_list" />

    <div class="form-divider"></div>
    <adresa-element ref="adresaElement" :base="fizicka.adrese_list" />

    <div class="form-divider"></div>

    <form-input :label="$t('forms.person.phys_pers.radno_lbl')" id="radno-vrijeme" ref="radnoVrijeme" :base="fizicka.radno_vrijeme"></form-input>
    <!-- *** OPIS **** -->
    <form-textarea :label="$t('forms.person.phys_pers.opis_lbl')" id="opis" ref="opis" :base="fizicka.opis"></form-textarea>
  </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import adresaElement from "@/components/formElements/adresaElement.vue";
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import formInputMultiple from "@/components/formElements/formInputMultiple.vue";
import person from "@/apiCallers/promise_handler_db/person"
import auth from '@/services/auth'
import graph from "@/services/graph"


import $ from "jquery";

export default {
  data() {
    return {
      refresh_key: 1,
      fizicka: {
        ime: "",
        prezime: "",
        oib: "",
        email_list: [],
        tel_br_list: [],
        adrese_list: [],
        web_list: [],
        radno_vrijeme: "",
        opis: "",
        // rodjendan: "",
        // Access token fetched via MSAL for calling Graph API
      accessToken: '',
      },
    };
  },
  async created() {
          this.accessToken = this.$store.state.aToken 

      await person.getSelf(this.accessToken).then(async (resp) => {
        let curr_user = resp.data;

        // Load avatar from MS Graph
        var avatarUrl = await graph.getPhoto();
        if (avatarUrl) {
          this.$store.state.avatar_image = avatarUrl;
        }
        this.$emit("finished", this.$store.state.avatar_image);


        this.$refs.imeFiz.$data.value = curr_user.ime == null ? '' : curr_user.ime;
        this.$refs.prezimeFiz.$data.value = curr_user.prezime == null ? '' : curr_user.prezime
        this.$refs.OIB.$data.value = curr_user.oib == null ? '' : curr_user.oib
        // this.$refs.godisnjiPrihod.$data.value = curr_user.god_prihod == null ? '':curr_user.god_prihod;
        this.$refs.adresaElement.$data.lista_adresa = curr_user.lokacija == null ? [] : curr_user.lokacija;

        this.$refs.email.$data.values = curr_user.email_list
        this.$refs.telefon.$data.values = curr_user.tel_br_list;
        this.$refs.stranica.$data.values = curr_user.web_list;
        this.$refs.radnoVrijeme.$data.value = curr_user.radno_vrijeme == null ? '' : curr_user.radno_vrijeme;
        this.$refs.opis.$data.value = curr_user.biljeske == null ? '' : curr_user.biljeske;
        // this.refresh_key++;
        // this.fizicka.rodjendan= curr_user.rodjendan==null ? '': new Date(curr_user.rodjendan).toISOString().substr(0, 10);

        
      })


    // });
    // }
  },
  mounted() {
    this.fizicka.ime = this.$refs.imeFiz.$data;
    this.fizicka.prezime = this.$refs.prezimeFiz.$data;
    this.fizicka.oib = this.$refs.OIB.$data;
    this.fizicka.adrese_list = this.$refs.adresaElement.$data;
    this.fizicka.email_list = this.$refs.email.$data;
    this.fizicka.tel_br_list = this.$refs.telefon.$data;
    this.fizicka.web_list = this.$refs.stranica.$data;
    this.fizicka.radno_vrijeme = this.$refs.radnoVrijeme.$data;
    this.fizicka.opis = this.$refs.opis.$data;
    console.log(this.fizicka)
    // this.fizicka.rodjendan = this.$refs.datumRodjenja.value;
  },

  props: ["invalid_elements"],
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "adresa-element": adresaElement,
    "form-autocomplete-single": formAutocompleteSingle,
    "form-input-multiple": formInputMultiple,
  },
};
</script>
